var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../domain';
/**
 * O historico que um paciente compartilhou por link.
 *
 * A tabela e a MESMA do detalhe do colaborador - os mesmos scopes de coluna e de
 * linha. E a reutilizacao que a referencia tambem faz: `pages/shared-history`
 * importa o `TableHistory` de `pages/CollaboratorDetailsPage/components`.
 */
let SharedHistoryScope = class SharedHistoryScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        /**
         * O endereco chegou sem codigo, e nao ha historico a mostrar.
         *
         * Acontece com um link truncado, com um endereco digitado a mao - que a
         * aplicacao recusa desde que so aceita o que ela mesma produziu - e com um
         * bookmark anterior a essa mudanca. Sem isto a tela ficava EM BRANCO, que nao
         * diz a quem abriu se o link esta errado, se venceu, ou se o site quebrou.
         */
        this.invalidLink = false;
        /**
         * O que o aviso de link sem historico diz - um sem codigo e um vencido sao dois casos.
         *
         * O vencido (410) caia no dialogo de erro inesperado, "Algo deu errado", com o
         * motivo real so na tela de tras; e o dialogo ficava aberto depois de sair dali.
         * Agora e um estado da tela, como o link sem codigo.
         */
        this.invalidTitle = 'Link inválido ou expirado';
        this.invalidText = 'Peça um novo link a quem compartilhou o histórico com você. Os links têm prazo de validade.';
        /** Os tres campos do cartao de cima, ja formatados - `--` quando nao ha dado. */
        this.patientName = '--';
        this.lastUpdate = '--';
        this.expiresAt = '--';
        /**
         * Qual visao esta aberta.
         *
         * O padrao e o PAINEL, e nao a lista: na referencia o `showDetails` comeca
         * falso, e quem chega pelo link ve os graficos.
         */
        this.view = 'chart';
        this.historyColumns = [];
        this.historyRows = [];
        this.historyPage = 1;
        this.historyPageCount = 1;
        this.onShowList = Scope.ASYNC_ACTION;
        this.onShowChart = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
    }
    /**
     * As paginas que o paginador oferece - lista pronta, e nao uma regra a aplicar.
     *
     * Deriva de `historyPage` e `pageCount`, os dois ja observados, entao muda junto com
     * eles. Fica aqui e nao na view para que outra renderizacao so LEIA: quem desenha
     * nao precisa saber que a janela tem cinco nem que ela se centra na atual.
     */
    get historyPageWindow() {
        return pageWindow(this.historyPage, this.historyPageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "invalidLink", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "invalidTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "invalidText", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "patientName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "lastUpdate", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "expiresAt", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SharedHistoryScope.prototype, "view", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], SharedHistoryScope.prototype, "analytics", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SharedHistoryScope.prototype, "historyColumns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], SharedHistoryScope.prototype, "historyLayout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SharedHistoryScope.prototype, "historyRows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "historyPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SharedHistoryScope.prototype, "historyPageCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], SharedHistoryScope.prototype, "bucket", void 0);
SharedHistoryScope = __decorate([
    Observable
], SharedHistoryScope);
export { SharedHistoryScope };
//# sourceMappingURL=shared-history.scope.js.map